import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Button, Form, Form as AntdForm, Input, Typography } from "antd";
import { connect } from "react-redux";
import {
  signUpTwoFA as signUpTwoFAAction,
  SignUpTwoFAAction,
  signUpResendEmail as signUpResendEmailAction,
  SignUpResendEmailAction,
} from "@triare/auth-redux/dist/saga/auth/signUp";
import { Action } from "@triare/auth-redux";
import Wrapper from "../../Wrapper";
import {
  createRulesForAntd,
  validationSignUpChangeEmail,
} from "../../../../../utils/validations";
import { useAuth } from "../../../../../store/auth";
import Submit from "../../../../Common/Form/Button/Submit";

import styles from "./index.module.scss";

const validationRules = createRulesForAntd(validationSignUpChangeEmail);

interface InformationProps {
  signUpResendEmail: (payload: SignUpResendEmailAction) => Action;
  signUpTwoFA: (payload: SignUpTwoFAAction) => Action;
}

function Information({
  signUpResendEmail,
  signUpTwoFA,
}: InformationProps): React.ReactNode {
  const {
    signUp: { data, loading, response, error, resendEmail },
  } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (!loading && response && !error) {
      setState(false);
    }
  }, [loading, response, error]);

  return (
    <Wrapper>
      <div className={styles.content}>
        <Typography.Title level={3}>
          Thank you for registering!
        </Typography.Title>

        <div>
          Please check the email message we&apos;ve sent you and follow the link
          to confirm your email address.
          {}
          If you do not receive this email within 10 minutes - please check your
          &quot;Spam&quot; folder.
        </div>

        <Button type="primary" onClick={() => navigate("/")}>
          Go to home page
        </Button>

        <br />

        <Button
          type="primary"
          loading={resendEmail.loading}
          onClick={() =>
            data && data.email
              ? signUpResendEmail({ email: data.email })
              : undefined
          }
        >
          Resend verification email
        </Button>

        <br />

        {state ? (
          <Form<{ email: string }>
            autoComplete="off"
            layout="vertical"
            onFinish={({ email }) => {
              if (data) {
                signUpTwoFA({
                  ...data,
                  email,
                });
              }
            }}
          >
            <AntdForm.Item
              name="email"
              required
              label={t("email")}
              rules={[validationRules]}
            >
              <Input
                placeholder={t("email") || "Email"}
                size="large"
                readOnly
                onFocus={(e) => e.currentTarget.removeAttribute("readonly")}
              />
            </AntdForm.Item>

            <Submit loading={loading} size="large">
              {t("signUp.text")}
            </Submit>
          </Form>
        ) : (
          <>
            <Button
              type="primary"
              loading={resendEmail.loading}
              onClick={() => setState(true)}
            >
              Change my email
            </Button>
            <br />
            <br />
          </>
        )}
      </div>
    </Wrapper>
  );
}

export default connect(null, {
  signUpResendEmail: signUpResendEmailAction,
  signUpTwoFA: signUpTwoFAAction,
})(Information);
